import React, {useState, useEffect} from 'react'
import { getSrc101Holders } from '../../util/stamp-api'
import { updateSrc101Domain } from '../../util/new-api'
import { Spinner } from "@material-tailwind/react";

export default function UpdateSrc101Domain() {
  const [loading, setLoading] = useState(false);
  const [hash, setHash] = useState('77fb147b72a551cf1e2f0b37dccf9982a1c25623a7fe8b4d5efaac566cf63fed');
  const [total, setTotal] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [current, setCurrent] = useState(0);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    handleInit();
  }, [])

  const handleInit = async () => {
    let response = await getSrc101Holders(hash, limit, 1);
    setTotal(response.total);
    setTotalPage(response.totalPages);
  }
  
  const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  const handleUpdate = async () => {
    setLoading(true);
    for(let i = 1; i<= totalPage; i++) {
      let data = await getSrc101Holders(hash, limit, i);
      for(let temp of data.data) {
        await updateSrc101Domain(temp.tokenid_utf8 + ".btc", temp.owner, temp.tokenid, temp.tokenid_utf8, "btc");
      }
      setCurrent(i * limit);
      sleep(100);
    }
    setLoading(false);
  }
  return (
    <div className="flex flex-col items-center gap-3">
      {
        loading ? 
        <>
          <Spinner className="h-16 w-16 text-gray-900/50 mt-[40px]" color="pink"/> 
          <div className="flex flex-row text-white font-bold text-[24px] mt-[80px]">
            {current} / {total}
          </div>
        </>
        : 
        <>
          <div className="bg-primary text-white rounded-md px-6 py-2 mt-10 cursor-pointer" onClick={handleUpdate}>
            UPDATE ADDRESS
          </div>
        </>
      }
    </div>
  )
}
